<div
  class="avatar-frame"
  [ngClass]="size"
  [class.admin]="emblem && Rights.hasRights(Rights.ADMIN, userRole())"
  [class.super]="emblem && isZefAdmin()"
>
  <div
    class="avatar-image z-fx-sc"
    [style.background-size]="fit"
    [style.background-image]="identity?.avatar || 'assets/images/user-placeholder.png' | encodeURI: 'url' | safeStyle"
  >
    @if (!!notifications) {
      <div class="alert-bubble">
        {{ notifications }}
      </div>
    }

    <mat-icon class="avatar-badge">zef_logo_console</mat-icon>
  </div>
</div>
